import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { translationConstants, viewPathConstants } from "../../../constants";

const DontHaveAAccount = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <hr className="verticalLine" />
      <p className="have-account d-flex gap-1">
        {t(translationConstants.dontHaveAccount)}
        <span
          onClick={() => {
            if (props.handleShowChooseRegistrationModal) {
              props.handleShowChooseRegistrationModal();
            }
            else {
              navigate(viewPathConstants.REGISTRATION);
            }
          }}
        >
          {t(translationConstants.registerHere)}
        </span>
      </p>
    </>
  );
};

export default DontHaveAAccount;
